"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[5416],{

/***/ 48899:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": () => (/* binding */ DriftSubscriptionConfirmationModal_DriftSubscriptionConfirmationModal)
});

// EXTERNAL MODULE: ../../node_modules/.pnpm/core-js@3.35.0/node_modules/core-js/modules/es.array.push.js
var es_array_push = __webpack_require__(85183);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(97458);
// EXTERNAL MODULE: ../../node_modules/.pnpm/react@18.2.0/node_modules/react/index.js
var react = __webpack_require__(52983);
// EXTERNAL MODULE: ../../node_modules/.pnpm/clsx@2.1.0/node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(78364);
// EXTERNAL MODULE: ./local_modules/analytics/index.ts
var analytics = __webpack_require__(66226);
// EXTERNAL MODULE: ./local_modules/analytics/context/index.ts
var context = __webpack_require__(5649);
// EXTERNAL MODULE: ./src/helpers/constants/index.ts + 8 modules
var constants = __webpack_require__(50556);
// EXTERNAL MODULE: ./src/helpers/errors/index.ts
var errors = __webpack_require__(83901);
// EXTERNAL MODULE: ./src/helpers/modifiers/formatPrice.ts
var formatPrice = __webpack_require__(72160);
// EXTERNAL MODULE: ./local_modules/links/index.ts + 4 modules
var links = __webpack_require__(69541);
// EXTERNAL MODULE: ./local_modules/notifications/manager.ts
var manager = __webpack_require__(72065);
// EXTERNAL MODULE: ./local_modules/router/util/contexts.ts
var contexts = __webpack_require__(84584);
// EXTERNAL MODULE: ./src/hooks/useAb.ts
var useAb = __webpack_require__(51827);
// EXTERNAL MODULE: ./local_modules/device/useDevice.ts
var useDevice = __webpack_require__(47361);
// EXTERNAL MODULE: ./local_modules/intl/useIntl.ts
var useIntl = __webpack_require__(56376);
// EXTERNAL MODULE: ./src/modules/subscription/subscriptionAddons/index.ts + 5 modules
var subscriptionAddons = __webpack_require__(4833);
// EXTERNAL MODULE: ./src/modules/subscription/drift/getFullDriftProductName.ts + 1 modules
var getFullDriftProductName = __webpack_require__(12049);
// EXTERNAL MODULE: ./src/components/feedback/Modal/Modal.tsx + 1 modules
var Modal = __webpack_require__(14830);
// EXTERNAL MODULE: ./src/components/dataDisplay/Text/Text.tsx + 1 modules
var Text = __webpack_require__(31627);
// EXTERNAL MODULE: ./src/components/dataDisplay/CheckedList/CheckedList.tsx
var CheckedList = __webpack_require__(90542);
// EXTERNAL MODULE: ./src/compositions/ProductImage/ProductImage.tsx
var ProductImage = __webpack_require__(63834);
// EXTERNAL MODULE: ./src/components/dataDisplay/Label/Label.tsx + 1 modules
var Label = __webpack_require__(10016);
;// CONCATENATED MODULE: ./src/compositions/modals/DriftSubscriptionConfirmationModal/components/DriftPreview/messages.ts
/* harmony default export */ const messages = ({
    label: {
        en: "Your first car scent"
    },
    defaultBrand: {
        en: "Drift"
    },
    retailPrice: {
        en: "Retail price"
    },
    subscriptionPrice: {
        en: "Your subscription price"
    },
    clipLabel: {
        en: "Free clip included"
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/DriftSubscriptionConfirmationModal/components/DriftPreview/images/default.png
const default_namespaceObject = __webpack_require__.p + "images/default_ac6cba.png";
;// CONCATENATED MODULE: ./src/compositions/modals/DriftSubscriptionConfirmationModal/components/DriftPreview/DriftPreview.tsx









const DriftPreview = (props)=>{
    const { className, data, isStarterSet, price, retailPrice } = props;
    const { details, product, tradingItem } = data || {};
    const intl = (0,useIntl/* default */.Z)();
    const { brand, image, name } = (0,react.useMemo)(()=>{
        const { driftDetails } = details || {};
        const { brandInfo, drift, name } = product || {};
        const { variety } = tradingItem || {};
        const driftObject = drift?.find((param)=>{
            let { starterSet } = param;
            return starterSet === isStarterSet;
        });
        const { description: driftDescription } = driftObject || {};
        const nameLine = (0,getFullDriftProductName/* default */.Z)({
            driftDescription,
            productName: name,
            varietyName: variety?.name,
            formatMessage: intl.formatMessage
        });
        return {
            brand: brandInfo?.name || messages.defaultBrand,
            image: driftDetails?.refill || default_namespaceObject,
            isStarterSet,
            name: nameLine
        };
    }, [
        details,
        intl,
        isStarterSet,
        product,
        tradingItem
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: (0,clsx/* default */.Z)(className, "relative block bg-light-beige px-16 pb-24 pt-16"),
        "data-testid": "driftSubscriptionCurrentProduct",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                message: messages.label,
                style: "h9"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex-start mt-24 flex items-center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                        className: "w-72 flex-none",
                        src: image,
                        bgColor: "light-beige"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "mx-16 flex-1",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: brand,
                                style: "t2"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                message: name,
                                style: "p2"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "flex-none text-right",
                        children: [
                            Boolean(retailPrice) && /*#__PURE__*/ (0,jsx_runtime.jsx)("s", {
                                className: "text-t2",
                                "aria-label": intl.formatMessage(messages.retailPrice),
                                children: retailPrice
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "text-t2",
                                "aria-label": intl.formatMessage(messages.subscriptionPrice),
                                children: price
                            })
                        ]
                    })
                ]
            }),
            isStarterSet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Label/* default */.ZP, {
                className: "-right-6 top-8",
                title: messages.clipLabel,
                bgColor: "gold-30",
                textColor: "black",
                direction: "right",
                withTail: true,
                absolute: true,
                "data-testid": "driftSubscriptionClipFree"
            })
        ]
    });
};
/* harmony default export */ const DriftPreview_DriftPreview = (DriftPreview);

;// CONCATENATED MODULE: ./src/compositions/modals/DriftSubscriptionConfirmationModal/images/default.png
const DriftSubscriptionConfirmationModal_images_default_namespaceObject = __webpack_require__.p + "images/default_7ab0db.png";
;// CONCATENATED MODULE: ./src/compositions/modals/DriftSubscriptionConfirmationModal/messages.ts
/* harmony default export */ const DriftSubscriptionConfirmationModal_messages = ({
    cancelModal: {
        title: {
            en: "Are you sure you want to cancel your Car Scent Club membership?"
        },
        text: {
            en: `
        You are currently subscribed to receive a Wood Car Freshener in each monthly order.
        If you cancel your subscription to the Car Scent Club, your main Scentbird subscription will remain active.
      `
        },
        confirmButton: {
            en: "Cancel car scent club subscription"
        },
        cancelButton: {
            en: "Keep car scent club subscription"
        }
    },
    subscribeModal: {
        title: {
            en: "Confirm your subscription to the Car Scent Club by Drift"
        },
        text: {
            en: "By clicking “Pay”, you are agreeing to receive a car freshener for an extra <strong>{price} per month</strong>."
        },
        extraText: {
            en: "*Clip will not be included."
        },
        confirmButton: {
            en: 'Pay <span class="text-gold-30">{price}</span> <s>{retailPrice}</s>'
        },
        checklist: [
            {
                en: "<strong>Ships together</strong> with your monthly fragrance."
            },
            {
                en: "<strong>Preview the next car scent</strong> in your account before we ship it out."
            },
            {
                en: "<strong>Cancel anytime</strong>, no worries."
            }
        ]
    },
    subscribeModalAb: {
        title: {
            en: "Upgrade for a Car Scent Club"
        },
        text: {
            en: `
        <p>
        By clicking "Confirm" you will be charged an extra <strong class="text-gold-70">{price}</strong> <s>{retailPrice}</s> per month and are agreeing to:
        </p>
      `
        },
        checklist: [
            {
                en: "Receive a <strong>different Car Scent every month.</strong>"
            },
            {
                en: "<strong>Ships together</strong> with your monthly fragrances."
            },
            {
                en: "<strong>Cancel anytime</strong>, no worries."
            }
        ],
        confirmButton: {
            en: "Confirm Car Scent Subscription — {price}"
        },
        subtitle: {
            en: "Your first car scent — {nameLine}"
        },
        freeClip: {
            en: "free<br/>clip"
        }
    },
    cancelNotification: {
        text: {
            en: "Your Car Scent Club membership has been successfully cancelled."
        }
    }
});

;// CONCATENATED MODULE: ./src/compositions/modals/DriftSubscriptionConfirmationModal/DriftSubscriptionConfirmationModal.tsx




















const DEFAULT_PRICE = 995;
const DEFAULT_RETAIL_PRICE = 1195;
const DriftSubscriptionConfirmationModal = (props)=>{
    const { action, withSubscribeRedirect = true, onConfirm, closeModal } = props;
    const isSubscribeAbEnabled = (0,useAb/* default */.Z)(constants/* default */.Z.abTests.candleDriftConfirmationPopup) === "b";
    const history = (0,contexts/* useHistory */.k6)();
    const { isMobile } = (0,useDevice/* default */.Z)();
    const intl = (0,useIntl/* default */.Z)();
    const [updateSubscriptionSettings, { isFetching: isSubmitting }] = (0,subscriptionAddons/* useSubscriptionSettingsUpdateWithWaiter */.D_)();
    const { driftSubscription } = (0,subscriptionAddons/* useDriftSubscription */.RD)({
        withProduct: true
    });
    const { currentMonth, priceDetails, state } = driftSubscription || {};
    const isStarterSet = Boolean(currentMonth) && state === "NEVER_SUBSCRIBED";
    const toEnable = action === "subscribe";
    (0,react.useEffect)(()=>{
        const event = toEnable ? "Drift subscribe confirmation popup display" : "Drift unsubscribe confirmation popup display";
        (0,analytics/* track */.j)(event);
    }, [
        toEnable
    ]);
    const confirm = (0,react.useCallback)(async ()=>{
        const { page, pageType } = (0,context/* getAnalyticsContext */.cV)();
        (0,analytics/* track */.j)(toEnable ? "Drift subscribe confirm click" : "Drift unsubscribe confirm click");
        try {
            await updateSubscriptionSettings({
                toEnable,
                type: "drift",
                // We have different images per subscription state
                withProduct: true,
                metadata: {
                    page,
                    pageType
                }
            });
            closeModal();
            (0,analytics/* track */.j)(toEnable ? "Drift subscribe success" : "Drift unsubscribe success");
            if (toEnable) {
                if (withSubscribeRedirect) {
                    history.push(links/* default */.ZP.driftSubscriptionThankYou);
                }
            } else {
                (0,manager/* openNotification */.Ym)("success", DriftSubscriptionConfirmationModal_messages.cancelNotification);
            // TODO: Step 2
            // openModal('driftSubscriptionCancelSuccessModal')
            }
            if (typeof onConfirm === "function") {
                onConfirm();
            }
        } catch (error) {
            (0,errors/* processError */.wY)(error);
        }
    }, [
        closeModal,
        history,
        onConfirm,
        toEnable,
        updateSubscriptionSettings,
        withSubscribeRedirect
    ]);
    const { image, subtitle, price, retailPrice } = (0,react.useMemo)(()=>{
        const { details, product, tradingItem } = currentMonth || {};
        const { driftDetails } = details || {};
        const { drift, name, prices } = product || {};
        const { variety } = tradingItem || {};
        const driftObject = drift?.find((param)=>{
            let { starterSet } = param;
            return starterSet === isStarterSet;
        });
        const { description: driftDescription } = driftObject || {};
        const nameLine = (0,getFullDriftProductName/* default */.Z)({
            driftDescription,
            productName: name,
            varietyName: variety?.name,
            formatMessage: intl.formatMessage
        });
        const subtitle = nameLine ? intl.formatMessage(DriftSubscriptionConfirmationModal_messages.subscribeModalAb.subtitle, {
            nameLine
        }) : undefined;
        const price = (0,formatPrice/* default */.Z)(priceDetails?.amountCents || DEFAULT_PRICE);
        const retailPrice = (0,formatPrice/* default */.Z)(prices?.retail?.amountCents || DEFAULT_RETAIL_PRICE);
        const image = driftDetails?.refill || DriftSubscriptionConfirmationModal_images_default_namespaceObject;
        return {
            subtitle,
            image,
            price,
            retailPrice
        };
    }, [
        currentMonth,
        intl,
        isStarterSet,
        priceDetails
    ]);
    const { title, text, checklist, cancelButton, confirmButton } = (0,react.useMemo)(()=>{
        if (toEnable) {
            const messagesData = isSubscribeAbEnabled ? DriftSubscriptionConfirmationModal_messages.subscribeModalAb : DriftSubscriptionConfirmationModal_messages.subscribeModal;
            return {
                title: messagesData.title,
                text: {
                    ...messagesData.text,
                    values: {
                        price,
                        retailPrice
                    }
                },
                checklist: messagesData.checklist?.map((message)=>({
                        ...message,
                        values: {
                            price,
                            retailPrice
                        }
                    })),
                confirmButton: {
                    ...messagesData.confirmButton,
                    values: {
                        price,
                        retailPrice
                    }
                }
            };
        }
        return {
            title: DriftSubscriptionConfirmationModal_messages.cancelModal.title,
            text: DriftSubscriptionConfirmationModal_messages.cancelModal.text,
            confirmButton: DriftSubscriptionConfirmationModal_messages.cancelModal.confirmButton,
            cancelButton: DriftSubscriptionConfirmationModal_messages.cancelModal.cancelButton
        };
    }, [
        isSubscribeAbEnabled,
        price,
        retailPrice,
        toEnable
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal/* default */.Z, {
        closeModal: closeModal,
        title: title,
        titleStyle: isSubscribeAbEnabled ? "sh5" : "sh3",
        text: text,
        primaryButton: {
            title: confirmButton,
            loading: isSubmitting,
            html: true,
            onClick: confirm
        },
        tertiaryButton: cancelButton && {
            title: cancelButton,
            onClick: ()=>closeModal()
        },
        "data-testid": toEnable ? "driftSubscriptionConfirmationModal" : "cancelDriftSubscriptionConfirmationModal",
        children: toEnable && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                !isStarterSet && !isSubscribeAbEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                    className: "-mt-20 mb-24",
                    message: DriftSubscriptionConfirmationModal_messages.subscribeModal.extraText,
                    style: "p3",
                    color: "gold-70"
                }),
                !isSubscribeAbEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(DriftPreview_DriftPreview, {
                    className: "mb-32",
                    data: currentMonth,
                    isStarterSet: isStarterSet,
                    price: price,
                    retailPrice: retailPrice
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckedList/* default */.Z, {
                    items: checklist,
                    gap: isSubscribeAbEnabled ? 16 : 24,
                    "data-testid": "driftSubscriptionBenefits"
                }),
                isSubscribeAbEnabled && /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                    children: [
                        !isStarterSet && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: "mt-24",
                            message: DriftSubscriptionConfirmationModal_messages.subscribeModal.extraText,
                            style: "p3",
                            color: "gold-70"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductImage/* default */.Z, {
                                    className: isMobile ? "w-[332rem]" : "w-[440rem]",
                                    src: image,
                                    bgColor: "gray-10",
                                    alt: "Drift car scent clip"
                                }),
                                isStarterSet && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx/* default */.Z)("absolute h-[100rem] w-[100rem] rounded-full bg-black p-4", isMobile ? "bottom-80 right-40" : "bottom-[116rem] right-[100rem]"),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "flex h-full items-center justify-center rounded-full border border-pink text-center",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                                            message: DriftSubscriptionConfirmationModal_messages.subscribeModalAb.freeClip,
                                            style: "h5",
                                            color: "gold-30",
                                            html: true
                                        })
                                    })
                                })
                            ]
                        }),
                        subtitle && /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.ZP, {
                            className: (0,clsx/* default */.Z)("relative mx-auto -mt-24 max-w-336 text-center"),
                            message: subtitle,
                            style: "p4",
                            color: "gray-90"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ const DriftSubscriptionConfirmationModal_DriftSubscriptionConfirmationModal = (DriftSubscriptionConfirmationModal);


/***/ })

}]);